var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCrossClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37492 0.607498L7.99992 6.2325L13.6249 0.607498L15.3924 2.375L9.76742 8L15.3924 13.625L13.6249 15.3925L7.99992 9.7675L2.37492 15.3925L0.607422 13.625L6.23242 8L0.607422 2.375L2.37492 0.607498Z",
    fill: "#505877"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCrossClose);
export default __webpack_public_path__ + "static/media/contact_cross_close.409614ca3e15ea6aadb3f175855d8217.svg";
export { ForwardRef as ReactComponent };